<template>
  <div
    ><ContentWrap title="直播间管理"
      ><el-form :inline="true"
        ><el-form-item label="标题"
          ><el-input
            show-word-limit
            :maxlength="128"
            v-model="q.title"
            clearable
            placeholder="搜索直播标题" /></el-form-item
        ><el-form-item label="状态"
          ><el-select v-model="q.status" clearable class="!w-140px"
            ><el-option
              v-for="d in getIntDictOptions(DICT_TYPE.LIVE_ROOM_STATUS)"
              :key="d.value"
              :label="d.label"
              :value="d.value" /></el-select></el-form-item
        ><el-form-item label="首页推荐"
          ><el-select v-model="q.recommended" clearable class="!w-120px"
            ><el-option label="已推荐" :value="true" /><el-option
              label="未推荐"
              :value="false" /></el-select></el-form-item
        ><el-form-item label="主播"
          ><LiveAnchorUserSelect
            v-model="q.anchorUserId"
            select-class="!w-260px"
            :status="undefined"
          /></el-form-item
        ><el-form-item
          ><el-button type="primary" @click="query"><Icon icon="ep:search" />查询</el-button
          ><el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button
          ><el-button v-hasPermi="['live:room:create']" @click="open()"
            ><Icon icon="ep:plus" />新建直播</el-button
          ></el-form-item
        ></el-form
      ></ContentWrap
    ><ContentWrap
      ><el-table :data="list" v-loading="loading" border
        ><el-table-column label="直播间编号" prop="id" width="100" align="center" />
        <el-table-column label="主播会员账号" min-width="140">
          <template #default="{ row }">
            <div>{{ row.anchorAccount || '--' }}</div>
            <div v-if="row.anchorUserId" class="sub-text">UID {{ row.anchorUserId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="会员认证资料" width="120" align="center">
          <template #default="{ row }">
            <el-button
              v-if="row.anchorId"
              link
              type="primary"
              @click="openCert(row)"
            >查看资料</el-button>
            <span v-else class="sub-text">未入驻</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="170"
          :formatter="dateFormatter"
        />
        <el-table-column label="房间状态" width="100">
          <template #default="{ row }">
            <dict-tag :type="DICT_TYPE.LIVE_ROOM_STATUS" :value="row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="房间标题" min-width="160">
          <template #default="{ row }">
            <div class="live-title" :title="row.title">{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="房间分类" width="110">
          <template #default="{ row }">{{ row.categoryName || '--' }}</template>
        </el-table-column>
        <el-table-column label="直播权限" width="110" align="center">
          <template #default="{ row }">
            <el-tag
              :type="
                row.livePermissionEnabled
                  ? 'success'
                  : row.livePermissionToggleable
                    ? 'info'
                    : 'warning'
              "
            >{{ row.livePermissionLabel || '未入驻' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="封面" width="100">
          <template #default="{ row }">
            <el-image :src="row.coverUrl" class="cover">
              <template #error>
                <div class="cover-error"><Icon icon="ep:picture" /></div>
              </template>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="totalViewCount" label="观看" width="70" />
        <el-table-column label="操作" width="420" fixed="right">
          <template #default="{ row }">
            <el-button link type="primary" @click="handleOpenStat(row)">数据明细</el-button>
            <el-button link type="primary" @click="open(row)">编辑</el-button>
            <el-button
              v-if="row.livePermissionToggleable && !row.livePermissionEnabled"
              link
              type="success"
              v-hasPermi="['live:anchor:update']"
              @click="toggleLivePermission(row, true)"
            >开启权限</el-button>
            <el-button
              v-if="row.livePermissionToggleable && row.livePermissionEnabled"
              link
              type="warning"
              v-hasPermi="['live:anchor:update']"
              @click="toggleLivePermission(row, false)"
            >关闭权限</el-button>
            <el-button
              v-if="row.status === 0"
              link
              type="warning"
              @click="action(Api.submitAudit, row.id, '已提交审核')"
            >提交审核</el-button>
            <el-button
              v-if="row.status === 10"
              link
              type="success"
              @click="action(() => Api.auditRoom(row.id, true), row.id, '审核通过')"
            >审核通过</el-button>
            <el-button
              v-if="row.status === 20"
              link
              type="danger"
              @click="action(Api.startRoom, row.id, '直播已开始')"
            >开播</el-button>
            <el-button
              v-if="row.status === 30"
              link
              type="warning"
              @click="action(Api.stopRoom, row.id, '直播已结束')"
            >结束</el-button>
            <el-button link type="danger" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        v-model:page="q.pageNo"
        v-model:limit="q.pageSize"
        :total="total"
        @pagination="load"
      />
    </ContentWrap>

    <Dialog v-model="certVisible" title="会员认证资料" width="560px">
      <el-descriptions v-if="certRow" :column="1" border>
        <el-descriptions-item label="主播编号">{{ certRow.anchorId || '--' }}</el-descriptions-item>
        <el-descriptions-item label="会员账号">{{
          certRow.anchorAccount || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="会员UID">{{
          certRow.anchorUserId || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{
          certRow.anchorRealName || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{
          certRow.anchorMobile || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="直播权限">{{
          certRow.livePermissionLabel || '--'
        }}</el-descriptions-item>
        <el-descriptions-item label="身份证人像面">
          <el-image
            v-if="certRow.idCardFront"
            :src="certRow.idCardFront"
            :preview-src-list="[certRow.idCardFront]"
            preview-teleported
            fit="contain"
            class="cert-img"
          />
          <span v-else class="sub-text">未上传</span>
        </el-descriptions-item>
        <el-descriptions-item label="身份证国徽面">
          <el-image
            v-if="certRow.idCardBack"
            :src="certRow.idCardBack"
            :preview-src-list="[certRow.idCardBack]"
            preview-teleported
            fit="contain"
            class="cert-img"
          />
          <span v-else class="sub-text">未上传</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <el-button
          v-if="certRow?.anchorId"
          type="primary"
          @click="goAnchorManage(certRow)"
        >去主播管理</el-button>
        <el-button @click="certVisible = false">关闭</el-button>
      </template>
    </Dialog>

    <Dialog v-model="visible" :title="form.id ? '编辑直播' : '新建直播'" width="650px"
      ><el-form
        ref="formRef"
        :model="form"
        :rules="withLiveInputLimits(rules, liveInputLimits)"
        label-width="100px"
        ><el-form-item label="直播模板" prop="templateId"
          ><el-select
            v-model="form.templateId"
            clearable
            filterable
            class="w-full"
            placeholder="选择后自动应用模板配置"
            @change="applyTemplate"
            ><el-option
              v-for="item in templates"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="直播标题" prop="title"
          ><el-input
            v-model="form.title"
            :maxlength="128"
            show-word-limit
            placeholder="请输入直播标题，最多128个字符" /></el-form-item
        ><el-form-item label="主播" prop="anchorUserId"
          ><LiveAnchorUserSelect
            v-model="form.anchorUserId"
            select-class="!w-full"
            :status="undefined"
            placeholder="搜索主播昵称 / 姓名 / 编号，或点选下方列表"
          /></el-form-item
        ><el-form-item prop="coverUrl" label="直播封面"><UploadImg v-model="form.coverUrl" /></el-form-item
        ><el-form-item label="直播来源" prop="sourceType"
          ><el-radio-group v-model="form.sourceType"
            ><el-radio :value="1">外部直播</el-radio><el-radio :value="2">云直播</el-radio
            ><el-radio :value="3">互动直播</el-radio></el-radio-group
          ></el-form-item
        ><el-form-item v-if="form.sourceType === 1" label="外部地址" prop="externalUrl"
          ><el-input
            show-word-limit
            :maxlength="1000"
            v-model="form.externalUrl"
            placeholder="https:// 或 HLS 地址" /></el-form-item
        ><el-form-item label="直播分类" prop="categoryId"
          ><el-select
            v-model="form.categoryId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择直播分类"
            ><el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id" /></el-select></el-form-item
        ><el-form-item label="计划开始"
          ><el-date-picker
            v-model="form.scheduledStartTime"
            type="datetime"
            value-format="x"
            class="w-full" /></el-form-item
        ><el-form-item prop="description" label="直播简介"
          ><el-input
            show-word-limit
            :maxlength="1000"
            v-model="form.description"
            type="textarea"
            :rows="3" /></el-form-item
        ><el-form-item label="首页推荐"
          ><el-switch v-model="form.recommended" />
          <span class="recommend-hint">开启后进入移动端直播首页精选区</span></el-form-item
        ><el-form-item v-if="form.recommended" label="推荐排序"
          ><el-input-number :precision="0" v-model="form.recommendSort" :min="0" :max="9999" />
          <span class="recommend-hint">数值越小越靠前</span></el-form-item
        ><el-form-item label="功能"
          ><el-checkbox v-model="form.recordingEnabled">自动录制</el-checkbox
          ><el-checkbox v-model="form.replayEnabled">允许回放</el-checkbox
          ><el-checkbox v-model="form.chatEnabled">聊天</el-checkbox
          ><el-checkbox v-model="form.likeEnabled">点赞</el-checkbox
          ><el-checkbox v-model="form.shareEnabled">分享</el-checkbox></el-form-item
        ><el-form-item label="本场优惠券"
          ><el-select
            v-model="form.voucherIdList"
            multiple
            filterable
            clearable
            collapse-tags
            collapse-tags-tooltip
            :multiple-limit="5"
            class="w-full"
            placeholder="选择优惠券模板（最多 5 张）"
            ><el-option
              v-for="item in couponTemplates"
              :key="item.id"
              :label="`${item.name}（¥${((item.discountPrice || 0) / 100).toFixed(0)}）`"
              :value="item.id" /></el-select
          ><span class="recommend-hint">观众端「更多 → 优惠券」可领取</span></el-form-item
        ></el-form
      ><template #footer
        ><el-button @click="visible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save">保存</el-button></template
      ></Dialog
    ></div
  >
</template>
<script setup lang="ts">
import { withLiveInputLimits } from '@/utils/liveInputLimits'
const liveInputLimits = { title: 128, externalUrl: 1000, description: 1000,
  coverUrl: 512 }

import { ContentWrap } from '@/components/ContentWrap'
import { Dialog } from '@/components/Dialog'
import * as Api from '@/api/live/room'
import { setLivePermission } from '@/api/live/anchor'
import * as TemplateApi from '@/api/live/template'
import * as CategoryApi from '@/api/live/category'
import { getCouponTemplatePage } from '@/api/mall/promotion/coupon/couponTemplate'
import { dateFormatter } from '@/utils/formatTime'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { useRouter } from 'vue-router'
import LiveAnchorUserSelect from '@/views/live/components/LiveAnchorUserSelect.vue'
const router = useRouter()
const message = useMessage(),
  loading = ref(false),
  saving = ref(false),
  visible = ref(false),
  certVisible = ref(false),
  certRow = ref<Api.LiveRoomVO | null>(null),
  list = ref<any[]>([]),
  templates = ref<any[]>([]),
  categories = ref<any[]>([]),
  couponTemplates = ref<any[]>([]),
  total = ref(0),
  formRef = ref()
const q = reactive({
  pageNo: 1,
  pageSize: 10,
  title: '',
  status: undefined as any,
  recommended: undefined as boolean | undefined,
  anchorUserId: undefined as number | undefined
})
const form = reactive<any>({})
const rules = {
  title: [
    { required: true, whitespace: true, message: '请输入标题', trigger: 'blur' },
    { max: 128, message: '直播标题最多128个字符', trigger: ['blur', 'change'] }
  ],
  sourceType: [{ required: true, message: '请选择来源' }],
  externalUrl: [
    {
      validator: (_: any, v: string, cb: any) =>
        form.sourceType !== 1 || /^https?:\/\//.test(v || '')
          ? cb()
          : cb(new Error('请输入有效的外部地址'))
    }
  ]
}
async function loadTemplates() {
  const data = await TemplateApi.getTemplatePage({ pageNo: 1, pageSize: 100 })
  templates.value = (data.list || []).filter((item: any) => item.status === 1)
}
async function loadCategories() {
  const res: any = await CategoryApi.listEnabledCategory()
  categories.value = res || []
}
async function loadCouponTemplates() {
  try {
    const data: any = await getCouponTemplatePage({ pageNo: 1, pageSize: 100, status: 0 })
    couponTemplates.value = data?.list || data || []
  } catch (_) {
    couponTemplates.value = []
  }
}
function parseVoucherIdList(raw?: string): number[] {
  if (!raw) return []
  return String(raw)
    .split(/[,，\s]+/)
    .map((s) => Number(s.trim()))
    .filter((n) => Number.isFinite(n) && n > 0)
    .slice(0, 5)
}
function applyTemplate(id?: number) {
  if (!id) return
  const template = templates.value.find((item) => item.id === id)
  if (!template) return
  let features: any = {}
  try {
    features = JSON.parse(template.featureConfig || '{}')
  } catch (_) {}
  if (!form.coverUrl && template.coverUrl) form.coverUrl = template.coverUrl
  if (!form.description && template.description) form.description = template.description
  if (features.recording !== undefined) form.recordingEnabled = !!features.recording
  if (features.replay !== undefined) form.replayEnabled = !!features.replay
  if (features.chat !== undefined) form.chatEnabled = !!features.chat
  if (features.like !== undefined) form.likeEnabled = !!features.like
  if (features.share !== undefined) form.shareEnabled = !!features.share
  message.success(`已应用模板“${template.name}”的配置`)
}
const sourceLabel = (s: number) =>
  ({ 1: '外部直播', 2: '云直播', 3: '互动直播', 4: '录播首播' })[s] || '未知'
const statusType = (s: number) =>
  (s === 30 ? 'danger' : s === 20 ? 'warning' : s === 50 ? 'success' : 'info') as any
async function load() {
  loading.value = true
  try {
    const r = await Api.getRoomPage(q)
    list.value = r.list || []
    total.value = r.total || 0
  } finally {
    loading.value = false
  }
}
const query = () => {
  q.pageNo = 1
  load()
}
const resetQuery = () => {
  q.title = ''
  q.status = undefined
  q.recommended = undefined
  q.anchorUserId = undefined
  query()
}
/** 打开指定直播间的数据明细。 */
const handleOpenStat = (row: any) =>
  router.push({
    path: '/ai-Application-center/live/data-analysis/stat',
    query: { liveId: String(row.id) }
  })
function openCert(row: Api.LiveRoomVO) {
  certRow.value = row
  certVisible.value = true
}
function goAnchorManage(row: Api.LiveRoomVO) {
  certVisible.value = false
  router.push({
    path: '/ai-Application-center/live/host-anchor',
    query: row.anchorUserId ? { userId: String(row.anchorUserId) } : undefined
  })
}
async function toggleLivePermission(row: Api.LiveRoomVO, allow: boolean) {
  if (!row.anchorUserId) {
    message.warning('该直播间未绑定主播会员')
    return
  }
  const tip = allow ? '确认开启该主播的直播权限？' : '确认关闭该主播的直播权限？'
  await message.confirm(tip)
  await setLivePermission(row.anchorUserId, allow)
  message.success(allow ? '已开启直播权限' : '已关闭直播权限')
  load()
}
function open(row?: any) {
  Object.assign(
    form,
    row
      ? {
          ...row,
          voucherIdList: parseVoucherIdList(row.voucherIds)
        }
      : {
          id: undefined,
          templateId: undefined,
          title: '',
          anchorUserId: undefined,
          coverUrl: '',
          description: '',
          sourceType: 1,
          categoryId: undefined,
          externalUrl: '',
          scheduledStartTime: '',
          recordingEnabled: false,
          replayEnabled: true,
          chatEnabled: true,
          likeEnabled: true,
          shareEnabled: true,
          recommended: false,
          recommendSort: 0,
          viewerCountVisible: true,
          visibility: 0,
          voucherIds: '',
          voucherIdList: [] as number[]
        }
  )
  visible.value = true
}
async function save() {
  await formRef.value?.validate()
  saving.value = true
  try {
    const payload = {
      ...form,
      voucherIds: (form.voucherIdList || []).join(',')
    }
    delete payload.voucherIdList
    form.id ? await Api.updateRoom(payload) : await Api.createRoom(payload)
    message.success('保存成功')
    visible.value = false
    load()
  } finally {
    saving.value = false
  }
}
async function action(fn: any, id: number, text: string) {
  await fn(id)
  message.success(text)
  load()
}
async function del(row: any) {
  await message.delConfirm()
  await Api.deleteRoom(row.id)
  message.success('删除成功')
  load()
}
onMounted(() => {
  loadTemplates()
  loadCategories()
  loadCouponTemplates()
  load()
})
</script>
<style scoped>
.live-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
  line-height: 23px;
  max-height: 46px;
}
.cover {
  width: 76px;
  height: 48px;
  border-radius: 6px;
}
.cover-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f5;
  color: #9aa3b1;
}
.recommend-hint {
  margin-left: 12px;
  color: var(--el-text-color-secondary);
  font-size: 12px;
}
.sub-text {
  color: var(--el-text-color-secondary);
  font-size: 12px;
  line-height: 1.4;
}
.cert-img {
  width: 220px;
  max-height: 140px;
  border-radius: 6px;
  background: #f5f7fa;
}
</style>
